import React, { useEffect, useState } from "react";
import { Button, Form, Input, Switch } from "antd";
import {
  dispatchtoast,
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../../Utils";
import { updateLogiMethod } from "../../../ApiServices/Apifun";

const ChangeLoginMethod = () => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [form] = Form.useForm();
  const validatePassword = (rule, value) => {
    const { getFieldValue } = form;
    if (value && value !== getFieldValue("new_password")) {
      return Promise.reject("The passwords do not match!");
    }
    return Promise.resolve();
  };
  const handleFinish = (val) => {};
  const login_method = getLocalStorageItem("login_method");
  const isOtp = login_method === "otp";

  useEffect(() => {
    form.setFieldsValue({
      login_method: login_method === "otp",
    });
  }, []);

  const onChange = (checked) => {
    console.log(checked);
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("login_method", checked ? "otp" : "pin");
    updateLogiMethod(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.msg);
          setLocalStorageItem("login_method", checked ? "otp" : "pin");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  return (
    <div className="w-full bg-white p-4 rounded-md mt-3 flex justify-start items-start">
      <Form
        form={form}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinishFailed={(err) => console.log(err)}
        // onFinish={(val) => handleFinish(val)}
      >
        <Form.Item
          name={`login_method`}
          label={"Login Method"}
          className="w-full "
          labelCol={{ span: 24 }}
          rules={[
            {
              required: true,
              message: "Enter Login Method!",
            },
          ]}
        >
          <Switch
            className="custom-switch"
            checked={isOtp}
            onChange={onChange}
            size="default"
            checkedChildren="OTP"
            unCheckedChildren="Pin"
          />
        </Form.Item>{" "}
      </Form>
    </div>
  );
};

export default ChangeLoginMethod;
